module.exports = __webpack_public_path__ + "img/second-0.c30924a0.webp";